import React, { useState, useEffect } from 'react'
import MunicipioRepository from './MunicipioRepository'
import { PureAutocomplete } from 'elentari'

export const loadMunicipios = async (inputValue, provinciaId) => {
  const response = await MunicipioRepository.find({
    paisId: 30,
    provinciaId,
    municipio: inputValue
  })
  if (response.ok) {
    return response.data.data
      .map(({ MUNICIPIO }) => ({
        id: MUNICIPIO,
        value: MUNICIPIO,
        label: MUNICIPIO
      }))
      .slice(0, 10)
  }
  return []
}

const Autocomplete = ({ input, meta, provinciaId, ...props }) => {
  const [value, setValue] = useState()

  useEffect(() => {
    const item = { id: input.value, value: input.value, label: input.value }
    setValue(item)
  }, [input.value])

  const onChange = item => {
    setValue(item)
    input.onChange(item ? item.id : undefined)
  }

  const touched = meta.touched || props.showError

  return (
    <PureAutocomplete
      {...props}
      meta={meta}
      error={meta.error && touched}
      textFieldProps={{
        onBlur: input.onBlur,
        helperText: touched && meta.error,
        error: meta.error && touched,
        InputLabelProps: {
          shrink: !!input.value || input.dirty
        }
      }}
      helperText={touched && meta.error}
      loadOptions={value => loadMunicipios(value, provinciaId)}
      onChange={onChange}
      value={value}
    />
  )
}

export default Autocomplete
